import { useCallback } from 'react';
import { IntlShape, useIntl } from 'react-intl';

function formatEnumValue<T extends string | number>(
  {
    titleKeys,
    formatMessage,
  }: {
    titleKeys: Partial<Record<T, string>>;
    formatMessage: IntlShape['formatMessage'];
  },
  value: Nullable<T>,
): string {
  if (value === null || value === undefined) {
    return '';
  }

  const messageId = titleKeys[value];

  if (messageId === undefined && typeof value === 'string' && value.endsWith('_NONE')) {
    return '';
  }

  return messageId ? formatMessage({ id: messageId }) : `${value}`;
}

/**
 * Never use this function directly! It is only meant to be used for specific enum formatters
 * @param titleKeys the title keys of the enum
 */
export function useEnumFormatter<T extends string | number>(titleKeys: Partial<Record<T, string>>) {
  const { formatMessage } = useIntl();

  return useCallback(
    (value: Nullable<T>) => formatEnumValue<T>({ titleKeys, formatMessage }, value),
    [formatMessage, titleKeys],
  );
}
